/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Grid,
  Box,
  Typography,
  Divider,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Switch
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LoopIcon from '@material-ui/icons/Loop';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import {
  KeyboardDatePicker,
} from '@material-ui/pickers';

import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';

// components
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch } from '../../context/LayoutContext';
import { useUserState } from '../../context/UserContext';
import useStyles from './styles';
import api from '../../services/api';
import { moneyToMask, toCurrency, maskToMoney } from '../../utils/mask';
import { VALOR_MIN, VALOR_MAX } from '../../utils/constants';

import {
  addDays,
  basicDate, dateToBD, getDayOfDate, isAfter
} from '../../utils/dateFormatter';
import { getError } from '../../utils/getResponseError';

export default function CadastroCobranca() {
  const history = useHistory();
  const classes = useStyles();
  const layoutDispatch = useLayoutDispatch();
  const { usuario } = useUserState();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState({
    id_produto: null,
    id_cliente: null,
    valor: null,
    recorrente: false,
    automatico: false,
    vencimento: new Date(),
    vencido_aceita: false,
    desconto: false,
    dias_antes: 1,
    vencido_dias_max: 30,
    vencido_juros: 0.5,
    vencido_multa: 0.5,
    desconto_valor: '',
    desconto_prazo: 5,
    periodo: 'mensal',
    cliente: null,
    produto: null,
    termino: false,
    data_termino: null
  });
  const [produtosOptions, setProdutosOptions] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [loadingProduto, setLoadingProduto] = useState(false);
  const [selectedProduto, setSelectedProduto] = useState('');
  const [clientesOptions, setclientesOptions] = useState([]);
  const [clientes, setclientes] = useState([]);
  const [loadingcliente, setLoadingcliente] = useState(false);
  const [selectedcliente, setSelectedcliente] = useState('');

  const [passo, setPasso] = useState(0);

  useEffect(() => {
    getProdutos();
    getClientes();
  }, []);

  async function handleSubmit() {
    setIsSubmiting(true);

    try {
      if (data.valor) {
        const valorNumerico = maskToMoney(data.valor);
        if (valorNumerico < VALOR_MIN || valorNumerico > VALOR_MAX) {
          setIsSubmiting(false);
          return setError(`O valor diferenciado deve estar entre R$ ${VALOR_MIN.toFixed(2).replace('.', ',')} e R$ ${VALOR_MAX.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`);
        }
      }
      const obj = {
        id_produto: data.id_produto,
        valor: data.valor ? maskToMoney(data.valor) : null,
        id_cliente: data.id_cliente,
        primeiro_vencimento: dateToBD(data.vencimento),
        dia_vencimento: getDayOfDate(data.vencimento),
        data_termino: data.data_termino && data.termino ? dateToBD(data.data_termino) : null,
        recorrente: data.recorrente,
        automatico: data.automatico,
        dias_antes: 5,
        vencido_aceita: data.vencido_aceita,
        vencido_dias_max: data.vencido_aceita ? data.vencido_dias_max : 0,
        vencido_multa: data.vencido_aceita ? data.vencido_multa : 0,
        vencido_juros: data.vencido_aceita ? data.vencido_juros : 0,
        desconto: data.desconto,
        desconto_prazo: data.desconto ? data.desconto_prazo : 0,
        desconto_valor: data.desconto ? maskToMoney(data.desconto_valor) : 0,
        terminado: !data.recorrente,
        periodo: !data.recorrente ? 'mensal' : data.periodo
      };
      const { data: response } = await api.post('cobranca', obj);
      Notification({
        type: 'shipped',
        message: 'Cobrança cadastrada',
        variant: 'contained',
        color: 'success',
      });

      if (response.id_cobranca) {
        history.push(`/app/cobrancas/${response.id_cobranca}`);
      } else {
        history.push('/app/cobrancas');
      }
    } catch (error) {
      console.log(error);
      setError(getError(error));
    }
    setIsSubmiting(false);
  }

  function handleType(recorrente) {
    setData({
      ...data,
      recorrente,
      automatico: recorrente,
    });
  }

  function handleProximo() {
    setError(null);

    if (passo === 1) {
      if (!data.id_produto) {
        return setError('Selecione um produto');
      }
      if (data.desconto && data.desconto_valor === '') {
        return setError('Defina um valor para o desconto');
      }
      if (data.termino && !data.data_termino) {
        return setError('Selecione uma data de término');
      }
      if (data.termino && !isAfter(data.data_termino, data.vencimento)) {
        return setError('Selecione uma data de término posterior a data de vencimento');
      }
      const existeValor = !!data.valor;
      if (data.desconto && existeValor) {
        if (maskToMoney(data.desconto_valor) >= maskToMoney(data.valor)) {
          return setError('O desconto precisa ser inferior ao valor diferenciado do produto');
        }
      }
      if (data.desconto && !existeValor) {
        if (maskToMoney(data.desconto_valor) >= data.produto.valor) {
          return setError('O desconto precisa ser inferior ao valor do produto');
        }
      }
    }
    if (passo === 2 && !data.id_cliente) {
      return setError('Selecione um cliente');
    }
    if (passo === 3) {
      return handleSubmit();
    }
    setPasso((prev) => prev + 1);
  }

  function handleAnterior() {
    setError(null);
    setPasso((prev) => prev - 1);
  }

  function handleInputProduto(query) {
    const find = produtos.find((p) => p.nome === query);
    setData((prev) => ({ ...prev, produto: find }));
    setSelectedProduto(query);
    if (find) {
      setData((prev) => ({ ...prev, id_produto: find.id_produto }));
    }
  }

  function handleInputCliente(query) {
    const find = clientes.find((p) => p.nome === query);
    setData((prev) => ({ ...prev, cliente: find }));
    setSelectedcliente(query);
    if (find) {
      setData((prev) => ({ ...prev, id_cliente: find.id_cliente }));
    }
  }

  async function getProdutos() {
    setLoadingProduto(true);
    try {
      const { data } = await api.get('/produto?limite=1000');
      setProdutos(data.dados);
      setProdutosOptions(data.dados.map((p) => p.nome));
    } catch (error) {
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
    }
    setLoadingProduto(false);
  }

  async function getClientes() {
    setLoadingcliente(true);
    try {
      const { data } = await api.get('/cliente?limite=1000');
      setclientes(data.dados);
      setclientesOptions(data.dados.map((p) => p.nome));
    } catch (error) {
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
    }
    setLoadingcliente(false);
  }

  function handleChange(e) {
    const { name, value: oldValue } = e.target;
    let value = oldValue;

    if (name === 'valor') {
      value = moneyToMask(value);
    }
    if (name === 'desconto_valor') {
      value = moneyToMask(value);
    }

    setData((old) => ({ ...old, [name]: value }));
  }

  return (
    <>
      <PageTitle
        title="Cadastro de cobrança"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar nova cobrança"
            className={classes.addButton}
            onClick={() => history.push('/app/cobrancas')}
          >
            <KeyboardReturnIcon />
          </IconButton>
        )}
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget disableWidgetMenu>

            <Grid xs={12}>
              <Typography variant="h5" color="textSecondary" noWrap>
                {passo === 0 && 'Selecione o tipo da cobrança'}
                {passo === 1 && 'Selecione os detalhes da cobrança'}
                {passo === 2 && 'Selecione o cliente'}
                {passo === 3 && 'Revise os dados da cobrança'}
              </Typography>
              <Divider className={classes.divider} />
            </Grid>
            <Box className={classes.centraliza}>
              {passo === 0 && (
                <>
                  <Box
                    onClick={() => handleType(false)}
                    className={`${classes.box} ${!data.recorrente ? classes.boxSelected : ''}`}
                  >
                    <Typography variant="h5" color="textPrimary" noWrap>
                      Individual
                    </Typography>
                    <AttachMoneyIcon />
                  </Box>
                  <Box
                    onClick={() => handleType(true)}
                    className={`${classes.box} ${data.recorrente ? classes.boxSelected : ''}`}
                  >
                    <Typography variant="h5" color="textPrimary" noWrap>
                      Recorrente
                    </Typography>
                    <LoopIcon />
                  </Box>
                </>
              )}
              {passo === 1 && (
                <>
                  <Grid container item xs={12} justify="flex-start">

                    <Grid item sm={6} xs={12}>
                      <Box px={3} py={2}>
                        <Autocomplete
                          value={selectedProduto}
                          onChange={(event, newValue) => {
                            handleInputProduto(newValue);
                          }}
                          id="controllable-states-demo"
                          options={produtosOptions}
                          // style={{ width: 300 }}
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Produto"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingProduto ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          noOptionsText="Sem opções cadastradas"
                        />
                      </Box>
                    </Grid>
                    {data.produto && (
                      <Grid item sm={3} xs={12}>
                        <Box px={3} py={2}>
                          <TextField
                            label="Valor do produto"
                            fullWidth
                            disabled
                            // value={data.produto.valor}
                            value={(() => toCurrency(data.produto.valor, true))()}
                            onChange={() => { }}
                          />
                        </Box>
                      </Grid>
                    )}
                    <Grid item sm={3} xs={12}>
                      <Box px={3} py={2}>
                        <TextField
                          onChange={handleChange}
                          label="Valor diferenciado"
                          fullWidth
                          value={data.valor}
                          name="valor"
                          inputProps={{
                            maxLength: 18,
                            min: VALOR_MIN,
                            max: VALOR_MAX
                          }}
                          helperText="Se em branco, herdará o valor do produto"
                        />
                      </Box>
                    </Grid>
                    {data.recorrente && (
                      <Grid item sm={4} xs={12}>
                        <Box px={3} pt={2}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Período da cobrança</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={data.periodo}
                              name="periodo"
                              onChange={handleChange}
                              required
                            >
                              <MenuItem value="mensal">Mensal</MenuItem>
                              <MenuItem value="trimestral">Trimestral</MenuItem>
                              <MenuItem value="semestral">Semestral</MenuItem>
                              <MenuItem value="anual">Anual</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                    )}
                    <Grid item sm={data.recorrente ? 4 : 5} xs={12}>
                      <Box px={3}>
                        <KeyboardDatePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Vencimento"
                          format="dd/MM/yyyy"
                          value={data.vencimento}
                          onChange={(vencimento) => setData((prev) => ({ ...prev, vencimento }))}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          disablePast
                          fullWidth
                        />
                      </Box>
                    </Grid>
                    {data.recorrente && (
                      <Grid item sm={4} xs={12}>
                        <Box px={3} pt={2}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Próximas faturas</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={data.dias_antes}
                              name="dias_antes"
                              onChange={handleChange}
                              required
                            >
                              <MenuItem value={1}>1 dia antes do vencimento</MenuItem>
                              <MenuItem value={2}>2 dias antes do vencimento</MenuItem>
                              <MenuItem value={3}>3 dias antes do vencimento</MenuItem>
                              <MenuItem value={4}>4 dias antes do vencimento</MenuItem>
                              <MenuItem value={5}>5 dias antes do vencimento</MenuItem>
                              <MenuItem value={6}>6 dias antes do vencimento</MenuItem>
                              <MenuItem value={7}>7 dias antes do vencimento</MenuItem>
                              <MenuItem value={8}>8 dias antes do vencimento</MenuItem>
                              <MenuItem value={9}>9 dias antes do vencimento</MenuItem>
                              <MenuItem value={10}>10 dias antes do vencimento</MenuItem>
                              <MenuItem value={11}>11 dias antes do vencimento</MenuItem>
                              <MenuItem value={12}>12 dias antes do vencimento</MenuItem>
                              <MenuItem value={13}>13 dias antes do vencimento</MenuItem>
                              <MenuItem value={14}>14 dias antes do vencimento</MenuItem>
                              <MenuItem value={15}>15 dias antes do vencimento</MenuItem>
                              <MenuItem value={16}>16 dias antes do vencimento</MenuItem>
                              <MenuItem value={17}>17 dias antes do vencimento</MenuItem>
                              <MenuItem value={18}>18 dias antes do vencimento</MenuItem>
                              <MenuItem value={19}>19 dias antes do vencimento</MenuItem>
                              <MenuItem value={20}>20 dias antes do vencimento</MenuItem>
                              <MenuItem value={21}>21 dias antes do vencimento</MenuItem>
                              <MenuItem value={22}>22 dias antes do vencimento</MenuItem>
                              <MenuItem value={23}>23 dias antes do vencimento</MenuItem>
                              <MenuItem value={24}>24 dias antes do vencimento</MenuItem>
                              <MenuItem value={25}>25 dias antes do vencimento</MenuItem>
                              <MenuItem value={26}>26 dias antes do vencimento</MenuItem>
                              <MenuItem value={27}>27 dias antes do vencimento</MenuItem>
                              <MenuItem value={28}>28 dias antes do vencimento</MenuItem>
                              <MenuItem value={29}>29 dias antes do vencimento</MenuItem>
                              <MenuItem value={30}>30 dias antes do vencimento</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                    )}
                    {data.recorrente && (
                      <Grid item sm={12} xs={12}>
                        <Box px={3} pt={5}>
                          <FormGroup row>
                            <FormControlLabel
                              control={(
                                <Switch
                                  name="checkedA"
                                  checked={data.termino}
                                  onChange={() => setData((prev) => ({ ...prev, termino: !prev.termino }))}
                                />
                              )}
                              label="Programar data de término?"
                            />
                          </FormGroup>
                        </Box>
                      </Grid>
                    )}
                    {data.termino && (
                      <Grid item sm={data.recorrente ? 4 : 5} xs={12}>
                        <Box px={3}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-dialog"
                            label="Data de término"
                            format="dd/MM/yyyy"
                            value={data.data_termino}
                            minDate={addDays(data.vencimento, 1)}
                            minDateMessage="A data de término deve ser superior a data de vencimento"
                            onChange={(data_termino) => setData((prev) => ({ ...prev, data_termino }))}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            disablePast
                            fullWidth
                          />
                        </Box>
                      </Grid>
                    )}
                    <Grid item sm={12} xs={12}>
                      <Box px={3} pt={5}>
                        <FormGroup row>
                          <FormControlLabel
                            control={(
                              <Switch
                                name="checkedA"
                                checked={data.vencido_aceita}
                                onChange={() => setData((prev) => ({ ...prev, vencido_aceita: !prev.vencido_aceita }))}
                              />
                            )}
                            label="Aceitar pagamento após o vencimento?"
                          />
                        </FormGroup>
                      </Box>
                    </Grid>
                    {data.vencido_aceita && (
                      <Grid container item xs={12} justify="flex-start">
                        <Grid item sm={4} xs={12}>
                          <Box px={3} py={2}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">Prazo máximo para pagamento</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.vencido_dias_max}
                                name="vencido_dias_max"
                                onChange={handleChange}
                                required
                              >
                                <MenuItem value={30}>30 dias</MenuItem>
                                <MenuItem value={60}>60 dias</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                        <Grid item sm={4} xs={12}>
                          <Box px={3} py={2}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">Multa</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.vencido_multa}
                                name="vencido_multa"
                                onChange={handleChange}
                                required
                              >
                                <MenuItem value={0.25}>0.25% do valor </MenuItem>
                                <MenuItem value={0.5}>0.5% do valor </MenuItem>
                                <MenuItem value={0.75}>0.75% do valor </MenuItem>
                                <MenuItem value={0.1}>1% do valor </MenuItem>
                                <MenuItem value={1.25}>1.25% do valor </MenuItem>
                                <MenuItem value={1.5}>1.5% do valor </MenuItem>
                                <MenuItem value={1.75}>1.75% do valor </MenuItem>
                                <MenuItem value={2}>2% do valor (R$ 1.013,13) (Máximo permitido por lei)</MenuItem>
                                <MenuItem value={3}>3% do valor </MenuItem>
                                <MenuItem value={4}>4% do valor </MenuItem>
                                <MenuItem value={5}>5% do valor </MenuItem>
                                <MenuItem value={6}>6% do valor </MenuItem>
                                <MenuItem value={7}>7% do valor </MenuItem>
                                <MenuItem value={8}>8% do valor </MenuItem>
                                <MenuItem value={9}>9% do valor </MenuItem>
                                <MenuItem value={10}>10% do valor </MenuItem>
                                <MenuItem value={11}>11% do valor </MenuItem>
                                <MenuItem value={12}>12% do valor </MenuItem>
                                <MenuItem value={13}>13% do valor </MenuItem>
                                <MenuItem value={14}>14% do valor </MenuItem>
                                <MenuItem value={15}>15% do valor </MenuItem>
                                <MenuItem value={16}>16% do valor </MenuItem>
                                <MenuItem value={17}>17% do valor </MenuItem>
                                <MenuItem value={18}>18% do valor </MenuItem>
                                <MenuItem value={19}>19% do valor </MenuItem>
                                <MenuItem value={20}>20% do valor </MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>

                        <Grid item sm={4} xs={12}>
                          <Box px={3} py={2}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">Juros</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.vencido_juros}
                                name="vencido_juros"
                                onChange={handleChange}
                                required
                              >
                                <MenuItem value={0.25}>0.25% ao mês </MenuItem>
                                <MenuItem value={0.5}>0.5% ao mês </MenuItem>
                                <MenuItem value={0.75}>0.75% ao mês </MenuItem>
                                <MenuItem value={0.1}>1% ao mês </MenuItem>
                                <MenuItem value={1.25}>1.25% ao mês </MenuItem>
                                <MenuItem value={1.5}>1.5% ao mês </MenuItem>
                                <MenuItem value={1.75}>1.75% ao mês </MenuItem>
                                <MenuItem value={2}>2% ao mês (R$ 1.013,13) (Máximo permitido por lei)</MenuItem>
                                <MenuItem value={3}>3% ao mês </MenuItem>
                                <MenuItem value={4}>4% ao mês </MenuItem>
                                <MenuItem value={5}>5% ao mês </MenuItem>
                                <MenuItem value={6}>6% ao mês </MenuItem>
                                <MenuItem value={7}>7% ao mês </MenuItem>
                                <MenuItem value={8}>8% ao mês </MenuItem>
                                <MenuItem value={9}>9% ao mês </MenuItem>
                                <MenuItem value={10}>10% ao mês </MenuItem>
                                <MenuItem value={11}>11% ao mês </MenuItem>
                                <MenuItem value={12}>12% ao mês </MenuItem>
                                <MenuItem value={13}>13% ao mês </MenuItem>
                                <MenuItem value={14}>14% ao mês </MenuItem>
                                <MenuItem value={15}>15% ao mês </MenuItem>
                                <MenuItem value={16}>16% ao mês </MenuItem>
                                <MenuItem value={17}>17% ao mês </MenuItem>
                                <MenuItem value={18}>18% ao mês </MenuItem>
                                <MenuItem value={19}>19% ao mês </MenuItem>
                                <MenuItem value={20}>20% ao mês </MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                      </Grid>
                    )}

                    <Grid item sm={12} xs={12}>
                      <Box px={3} pt={5}>
                        <FormGroup row>
                          <FormControlLabel
                            control={(
                              <Switch
                                name="checkedA"
                                checked={data.desconto}
                                onChange={() => setData((prev) => ({ ...prev, desconto: !prev.desconto }))}
                              />
                            )}
                            label="Oferecer desconto para pagamento antecipado?"
                          />
                        </FormGroup>
                      </Box>
                    </Grid>
                    {data.desconto && (
                      <Grid container item xs={12} justify="flex-start">
                        <Grid item sm={6} xs={12}>
                          <Box px={3} py={2}>
                            <TextField
                              onChange={handleChange}
                              required
                              label="Valor do desconto"
                              fullWidth
                              value={data.desconto_valor}
                              name="desconto_valor"
                            />
                          </Box>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                          <Box px={3} py={2}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">Até qual dia o desconto ficará válido?</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.desconto_prazo}
                                name="desconto_prazo"
                                onChange={handleChange}
                                required
                              >
                                <MenuItem value={0}>Até 0 dias</MenuItem>
                                <MenuItem value={1}>Até 1 dias</MenuItem>
                                <MenuItem value={2}>Até 2 dias</MenuItem>
                                <MenuItem value={3}>Até 3 dias</MenuItem>
                                <MenuItem value={4}>Até 4 dias</MenuItem>
                                <MenuItem value={5}>Até 5 dias</MenuItem>
                                <MenuItem value={6}>Até 6 dias</MenuItem>
                                <MenuItem value={7}>Até 7 dias</MenuItem>
                                <MenuItem value={8}>Até 8 dias</MenuItem>
                                <MenuItem value={9}>Até 9 dias</MenuItem>
                                <MenuItem value={10}>Até 10 dias</MenuItem>
                                <MenuItem value={11}>Até 11 dias</MenuItem>
                                <MenuItem value={12}>Até 12 dias</MenuItem>
                                <MenuItem value={13}>Até 13 dias</MenuItem>
                                <MenuItem value={14}>Até 14 dias</MenuItem>
                                <MenuItem value={15}>Até 15 dias</MenuItem>
                                <MenuItem value={16}>Até 16 dias</MenuItem>
                                <MenuItem value={17}>Até 17 dias</MenuItem>
                                <MenuItem value={18}>Até 18 dias</MenuItem>
                                <MenuItem value={19}>Até 19 dias</MenuItem>
                                <MenuItem value={20}>Até 20 dias</MenuItem>
                                <MenuItem value={21}>Até 21 dias</MenuItem>
                                <MenuItem value={22}>Até 22 dias</MenuItem>
                                <MenuItem value={23}>Até 23 dias</MenuItem>
                                <MenuItem value={24}>Até 24 dias</MenuItem>
                                <MenuItem value={25}>Até 25 dias</MenuItem>
                                <MenuItem value={26}>Até 26 dias</MenuItem>
                                <MenuItem value={27}>Até 27 dias</MenuItem>
                                <MenuItem value={28}>Até 28 dias</MenuItem>
                                <MenuItem value={29}>Até 29 dias</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </>
              )}
              {passo === 2 && (
                <>
                  <Grid container item xs={12} justify="flex-start">

                    <Grid item xs={12}>
                      <Box px={3} py={2}>
                        <Autocomplete
                          value={selectedcliente}
                          onChange={(event, newValue) => {
                            handleInputCliente(newValue);
                          }}
                          disableClearable
                          id="controllable-states-demo"
                          options={clientesOptions}
                          // style={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Cliente"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingcliente ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          noOptionsText="Sem opções cadastradas"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </>
              )}
              {passo === 3 && (
                <>
                  <Grid container item xs={12} justify="flex-start" spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Widget
                        title="Cobrança"
                        elevation={3}
                        disableWidgetMenu
                        styleBody={classes.customBoxBg}
                      >
                        Produto:
                        {' '}
                        {data.produto && data.produto.nome}
                        <br />
                        Tipo da cobrança:
                        {' '}
                        {data.recorrente ? 'recorrente' : 'individual'}
                        <br />
                        {data.recorrente && (
                          <>
                            Período:
                            {' '}
                            {data.periodo}
                            <br />
                          </>
                        )}
                        {data.termino && (
                          <>
                            Término em:
                            {' '}
                            {basicDate(data.data_termino)}
                            <br />
                          </>
                        )}
                        {data.recorrente && (
                          <>
                            Próximas faturas:
                            {' '}
                            {data.dias_antes}
                            {' '}
                            dia
                            {`${data.dias_antes === 1 ? '' : 's'}`}
                            {' '}
                            antes do vencimento
                            <br />
                          </>
                        )}
                        Vencimento:
                        {' '}
                        {basicDate(data.vencimento)}
                        <br />
                        Valor da cobrança: R$
                        {data.valor && data.valor !== '' && toCurrency(data.valor)}
                        {!data.valor && toCurrency(data.produto.valor)}
                      </Widget>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Widget
                        title="Cliente"
                        elevation={3}
                        disableWidgetMenu
                        styleBody={classes.customBoxBg}
                      >
                        Razão Social:
                        {' '}
                        {data.cliente && data.cliente.nome}
                        {' '}
                        <br />
                        CNPJ:
                        {' '}
                        {data.cliente && data.cliente.cnpj}
                        {' '}
                        <br />
                        Email:
                        {' '}
                        {data.cliente && data.cliente.email}
                        {' '}
                        <br />
                        Telefone:
                        {' '}
                        {data.cliente && data.cliente.telefone}
                      </Widget>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Widget
                        title="Multa"
                        elevation={3}
                        disableWidgetMenu
                        styleBody={classes.customBoxBg}
                      >
                        {data.vencido_aceita && (
                          <>
                            Aceitar após o vencimento: sim
                            {' '}
                            <br />
                            Aplicar multa:
                            {' '}
                            {data.vencido_multa > 0 ? 'sim' : 'não'}
                            <br />
                            {data.vencido_multa > 0 && (
                              <>
                                Multa:
                                {' '}
                                {data.vencido_multa}
                                %
                                {' '}
                                <br />
                              </>
                            )}
                            Dias máximos após o vencimento:
                            {' '}
                            {data.vencido_dias_max}
                            {' '}
                            dias
                            <br />
                          </>
                        )}
                        {!data.vencido_aceita && 'Não aceitar após o vencimento'}
                      </Widget>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Widget
                        title="Juros"
                        elevation={3}
                        disableWidgetMenu
                        styleBody={classes.customBoxBg}
                      >
                        {data.vencido_aceita && (
                          <>
                            Aceitar após o vencimento: sim
                            {' '}
                            <br />
                            Aplicar juros:
                            {' '}
                            {data.vencido_juros > 0 ? 'sim' : 'não'}
                            <br />
                            {data.vencido_juros > 0 && (
                              <>
                                Juros:
                                {' '}
                                {data.vencido_juros}
                                % ao mês
                                {' '}
                                <br />
                              </>
                            )}
                          </>
                        )}
                        {!data.vencido_aceita && 'Não aceitar após o vencimento'}
                      </Widget>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Widget
                        title="Desconto"
                        elevation={3}
                        disableWidgetMenu
                        styleBody={classes.customBoxBg}
                      >
                        {data.desconto && (
                          <>
                            Aplicar desconto: sim
                            {' '}
                            <br />
                            Desconto: R$
                            {data.desconto_valor}
                            <br />
                            Prazo: até
                            {' '}
                            {data.desconto_prazo}
                            {' '}
                            dias
                          </>
                        )}
                        {!data.desconto && 'Sem desconto de antecipação'}
                      </Widget>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
            {error && (
              <Grid item xs={12}>
                <Box px={3} pt={3}>
                  <Alert severity="error">{error}</Alert>
                </Box>
              </Grid>
            )}
            <Grid container item xs={12} justify="flex-start">
              <Grid item xs={6} sm={4}>
                <Box px={3} pt={8}>
                  <Button
                    variant="contained"
                    color="default"
                    type="button"
                    onClick={handleAnterior}
                    disabled={isSubmiting || (passo === 0)}
                  >
                    {isSubmiting ? <CircularProgress size={25} /> : 'Anterior'}
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12} sm={4} order={{ xs: 3 }} className={classes.item2}>
                <Box pt={6}>
                  <Stepper activeStep={passo} alternativeLabel>
                    <Step>
                      <StepLabel />
                    </Step>
                    <Step>
                      <StepLabel />
                    </Step>
                    <Step>
                      <StepLabel />
                    </Step>
                  </Stepper>
                </Box>
              </Grid>

              <Grid item xs={6} sm={4} order={{ xs: 4 }} className={classes.item3}>
                <Box px={3} pt={8} className={classes.botaoDireta}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="button"
                    onClick={handleProximo}
                    disabled={isSubmiting}
                  >
                    <>
                      {isSubmiting && <CircularProgress size={25} />}
                      {!isSubmiting && passo === 3 && 'Salvar'}
                      {!isSubmiting && passo !== 3 && 'Próximo'}
                    </>
                  </Button>
                </Box>
              </Grid>
            </Grid>

          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
